import Field from "./Field";

const Number = (props) => {




    return <Field type={'number'} min={0} max={9999} step={1} {...props} />;

}

export default Number;